import Link from "next/link";
import {
  ICountryCategory,
  IRoamingInternationalCountry,
  IZone,
} from "@nju/data-access-portal-dashboard";
import { portalRoutes } from "@nju/routes";
import { A, Text } from "@nju/ui";

interface IZoneCountryProps {
  userId: string | undefined;
  category: ICountryCategory;
  zone: IZone["name"];
  country: IRoamingInternationalCountry;
  countryFromUrl: string | undefined;
}

export function ZoneCountry({
  userId,
  category,
  zone,
  country,
  countryFromUrl,
}: IZoneCountryProps) {
  return (
    <Link
      href={
        category === "INTERNATIONAL"
          ? portalRoutes.mojeKonto.uslugiDodatkowe.rozmowyMiedzynarodowe.podsumowanie.get(
              {
                ...(userId && { userId }),
                country: country.displayName.pl,
                zone,
              },
            )
          : portalRoutes.mojeKonto.uslugiDodatkowe.roaming.index.get({
              ...(userId && { userId }),
              country: country.displayName.pl,
            })
      }
      key={country.displayName.pl}
      passHref={true}
    >
      <A display="inlineFlex" size="inline" variant="neutral">
        <Text
          tone="accent"
          withUnderline={country.displayName.pl === countryFromUrl}
        >
          {country.displayName.pl}
        </Text>
      </A>
    </Link>
  );
}
